/**
 * localStore.js — anonymous, non-sensitive UX preferences only.
 *
 * SECURITY NOTE: We intentionally use localStorage here because the stored
 * values are NOT sensitive:
 *   - adk_mylist: user's personal watchlist (title, thumbnail, ids)
 *   - adk_progress: watch progress percentages per video (no PII)
 * Authentication tokens are stored in httpOnly, secure cookies (see server.py
 * set_cookie in /api/auth/login) and NEVER in localStorage.
 * If sensitive data is ever introduced, migrate that specific slice to
 * an httpOnly cookie or an encrypted server-side session.
 */
const KEYS = {
    myList: "adk_mylist",
    progress: "adk_progress",
};

function read(key, fallback) {
    try {
        const v = localStorage.getItem(key);
        return v ? JSON.parse(v) : fallback;
    } catch {
        return fallback;
    }
}
function write(key, val) {
    localStorage.setItem(key, JSON.stringify(val));
}

/* -------- My List -------- */
export function getMyList() {
    return read(KEYS.myList, []);
}
export function toggleMyList(item) {
    const list = getMyList();
    const idx = list.findIndex((x) => x.id === item.id && x.type === item.type);
    if (idx >= 0) list.splice(idx, 1);
    else list.push(item);
    write(KEYS.myList, list);
    return list;
}
export function isInMyList(id, type) {
    return getMyList().some((x) => x.id === id && x.type === type);
}

/* -------- Watch Progress -------- */
export function getAllProgress() {
    return read(KEYS.progress, {});
}
export function getProgress(id) {
    return getAllProgress()[id] || null;
}
export function setProgress(id, entry) {
    const all = getAllProgress();
    all[id] = { ...entry, updated_at: Date.now() };
    write(KEYS.progress, all);
}
export function getContinueWatching() {
    const all = getAllProgress();
    return Object.entries(all)
        .map(([id, v]) => ({ id, ...v }))
        .filter((v) => (v.percent || 0) > 2 && (v.percent || 0) < 95)
        .sort((a, b) => (b.updated_at || 0) - (a.updated_at || 0));
}
